import { NgModule }                      from '@angular/core';
import { CommonModule }                  from '@angular/common';

import { SubscriptionsRoutingModule }    from './subscriptions-routing.module';
import { SubscriptionListComponent }     from './subscription-list.component';
import { SubscriptionDetailComponent }   from './subscription-detail.component';
import { SubscriptionSettingsComponent } from './subscription-settings.component';
import { SubscriptionUsersComponent }    from './subscription-users.component';
import { SubscriptionInvoicesComponent } from './subscription-invoices.component';
import { SubscriptionTeamsComponent }    from './subscription-teams.component';
import { SubscriptionHistoryComponent }    from './subscription-history.component';
import { SharedModule }                  from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SubscriptionsRoutingModule,
    SharedModule
  ],
  declarations: [
    SubscriptionListComponent,
    SubscriptionDetailComponent,
    SubscriptionSettingsComponent,
    SubscriptionUsersComponent,
    SubscriptionInvoicesComponent,
    SubscriptionTeamsComponent,
    SubscriptionHistoryComponent
  ],
  providers: []
})
export class SubscriptionsModule { }



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/subscriptions/subscriptions.module.ts